import { createContext } from 'react'

export type UserData = {
  token: string;
  username: string;
  usertype: string;
};

export type UserDataContextType = {
  setUserData: (data?: UserData) => void;
  getUserData: () => UserData | null;
  clearUserData: () => void;
  isLoading: boolean;
  userData: UserData | null;
};

export const UserDataContext = createContext<UserDataContextType | null>(null)